import { message, notification } from 'antd'
import { generateMessageError } from 'modules/core/utils'
import i18n from 'i18next'

//ver de tener algun endpoint o filtro que me traiga todas los valores pq ahora me trae por pagina.
export const onManagement = ({
  form,
  setIsLoading,
  groupAliasDimension,
  onRefetch,
  onClose,
  sendUserDataToGTM,
}) => {
  form.validateFields().then((values) => {
    setIsLoading(true)
    groupAliasDimension(values)
      .then(() =>
        onRefetch().then(() => {
          message.success(i18n.t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
          onClose()
          sendUserDataToGTM()
        }),
      )
      .catch((error) => {
        notification.error({
          message: i18n.t('FEEDBACK_DEFAULT_ERROR'),
          description: generateMessageError(error, 'FEEDBACK_SAVE_CHANGES_FAIL'),
          duration: 0,
        })
        onClose()
      })
  })
}
